import React from "react";

import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import share from "../../assets/images/icons/share.svg";
import { MdShare } from "react-icons/md";

const ShareDataComp = ({ showSocial, setShowSocial, active }) => {
  return (
    <div className="me-3 d-flex z-[9999] align-items-center justify-content-center">
      <div
        className={` position-relative z-[99999] h-fit rounded-4 ${
          showSocial ? "scale1" : "scale0"
        }`}
      >
        <div
          className="mobile-share-details-link"
          style={{
            zIndex: "9999",
          }}
        >
          <img
            width="16"
            onClick={() => setShowSocial(false)}
            height="16"
            src="https://img.icons8.com/sf-black/64/delete-sign.png"
            alt="delete-sign"
            style={{
              zIndex: "9999",
            }}
            className="m-3 cursor-pointer position-absolute position1"
          />
          <FacebookShareButton url={`${window.location}`}>
            <FacebookIcon size={40} round={true} />
          </FacebookShareButton>
          <WhatsappShareButton url={`${window.location}`}>
            <WhatsappIcon size={40} round={true} />
          </WhatsappShareButton>

          <EmailShareButton url={`${window.location}`}>
            <EmailIcon size={40} round={true} />
          </EmailShareButton>
          <LinkedinShareButton url={`${window.location}`}>
            <LinkedinIcon size={40} round={true} />
          </LinkedinShareButton>
          <TelegramShareButton url={`${window.location}`}>
            <TelegramIcon size={40} round={true} />
          </TelegramShareButton>
          <TwitterShareButton url={`${window.location}`}>
            <TwitterIcon size={40} round={true} />
          </TwitterShareButton>
        </div>
      </div>

      <MdShare
        className={`cursor-pointer text-3xl text-white pt-1 rounded-full ${
          !active ? "mt-5 me-2 bg-[#5A5956] p-2 rounded-5" : ""
        }`}
        onClick={() => setShowSocial(!showSocial)}
        style={{
          zIndex: "1",
          position: "absolute",
          top: "3px",
          right: "5px",
        }}
      />
    </div>
  );
};

export default ShareDataComp;
